import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Swal from "sweetalert2";
import Acciones from "../Acciones";
import { getTipoEtapas } from "../../../../../redux/Sections/Estados/actions";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import { evaluacionesService } from "../../../../../_services/evaluaciones.service";
import { tipoEtapasService } from "../../../../../_services/tipoEtapas.service";
import { setLoading } from "../../../../../redux/Loading/actions";

const EvaluacionesConfig = () => {
  const {
    tipoEtapas,
  } = useSelector(e => e.dashboard);
  const dispatch = useDispatch();

  const [edit, setEdit] = useState("");
  const [values, setValues] = useState({});
  const [tipoTiempo, setTipoTiempo] = useState({});
  const [permitidosData, setPermitidosData] = useState([]);
  const [permitido, setPermitido] = useState({});

  useEffect(() => {
    dispatch(getTipoEtapas(3));
  }, []);

  useEffect(() => {
    getEvaluacionesConfig();
  }, []);

  useEffect(() => {
    if (permitidosData?.length) {
      for (const i of permitidosData) {
        setPermitido((prev) => {
          return {
            ...prev,
            [i.categoria]: i.maximo
          };
        });
      }
    }
  }, [permitidosData]);

  useEffect(() => {
    if (tipoEtapas?.length) {
      for (const i of tipoEtapas) {
        setValues((prev) => {
          return {
            ...prev,
            [i.tipo]: i.tiempo
          };
        });

        setTipoTiempo((prev) => {
          return {
            ...prev,
            [i.tipo]: i.tipo_tiempo
          };
        });
      }
    }
  }, [tipoEtapas]);

  const getEvaluacionesConfig = async () => {
    const res = await evaluacionesService.getEvaluacionesConfig();
    setPermitidosData(res);
  };

  const handleSave = (tipo) => {
    Swal.fire({
      title: "¿Esta seguro de guardar los cambios?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(setLoading(true));

        const response = await tipoEtapasService.updateTipoEtapas({
          tiempo: values[tipo],
          tipo_tiempo: tipoTiempo[tipo],
          tipo
        });

        if (response.ok) {
          dispatch(getTipoEtapas(3));
          dispatch(setLoading(false));

          return Swal.fire({
            title: "Exito!",
            text: "Los datos es guardaron correctamente.",
            icon: "success",
            willClose: () => {
              setEdit("");
            }
          });
        }
        else {
          dispatch(setLoading(false));
          return Swal.fire(
            "Error!",
            response.error || "Ocurrio un error, intentelo nuevamente.",
            "error"
          );
        }
      }
    });
  };

  const handleSavePermitidos = (categoria) => {
    Swal.fire({
      title: "¿Esta seguro de guardar los cambios?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(setLoading(true));

        const response = await evaluacionesService.updateEvaluacionesConfig({
          maximo: permitido[categoria],
          categoria
        });

        if (response.ok) {
          await getEvaluacionesConfig();
          dispatch(setLoading(false));

          return Swal.fire({
            title: "Exito!",
            text: "Los datos es guardaron correctamente.",
            icon: "success",
            willClose: () => {
              setEdit("");
            }
          });
        }
        else {
          dispatch(setLoading(false));
          return Swal.fire(
            "Error!",
            response.error || "Ocurrio un error, intentelo nuevamente.",
            "error"
          );
        }
      }
    });
  };

  const handleEdit = (value, maximos) => {
    if (maximos) {
      let perm = permitidosData.find(e => e.categoria === value);
      setPermitido({
        ...permitido,
        [value]: perm.maximo
      });
    }
    else {
      let evaluacion = tipoEtapas.find(e => e.tipo === value);
      setValues({
        ...values,
        [value]: evaluacion.tiempo
      });
      setTipoTiempo({
        ...tipoTiempo,
        [value]: evaluacion.tipo_tiempo
      });
    }

    setEdit(value);
  };

  const handleCancel = (value, maximos) => {
    if (maximos) {
      let perm = permitidosData.find(e => e.categoria === value);
      setPermitido({
        ...permitido,
        [value]: perm.maximo
      });
    }
    else {
      let evaluacion = tipoEtapas.find(e => e.tipo === value);
      setValues({
        ...values,
        [value]: evaluacion.tiempo
      });
      setTipoTiempo({
        ...tipoTiempo,
        [value]: evaluacion.tipo_tiempo
      });
    }

    setEdit("");
  };

  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value
    });
  };

  const handleSelect = (e) => {
    setTipoTiempo({
      ...tipoTiempo,
      [e.target.name]: e.target.value
    });
  };

  const handlePermitidos = (e) => {
    setPermitido({
      ...permitido,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div style={{ width: "80%" }} className="eval-config">
      <div className="p-3" >
        <div>
          {
            tipoEtapas?.length ? tipoEtapas.map((e) => {
              return (
                <div key={e.tipo} className="d-flex justify-content-between" >
                  <div className="">
                    <div className="juicios-tipo">{e.nombre}</div>
                  </div>
                  <div className="d-flex">
                    <div className="evaluacion-form">
                      <Form.Control name={e.tipo} value={values[e.tipo]} onChange={handleChange} disabled={edit !== e.tipo} />
                      <Form.Control as={"select"} name={e.tipo} value={tipoTiempo[e.tipo]} onChange={handleSelect} disabled={edit !== e.tipo} >
                        <option value="minute">Minutos</option>
                        <option value="hour">Horas</option>
                        <option value="day">Dias</option>
                        <option value="year">Años</option>
                      </Form.Control>
                    </div>
                    <Acciones categoria={e.tipo} edit={edit} handleEdit={handleEdit} handleCancel={handleCancel} handleSave={handleSave} />
                  </div>
                </div>
              );
            }) : null
          }
        </div>
        <div className="my-4">
          <table className="w-full">
            <tr style={{ background: "#0477AD", color: "white" }}>
              <th></th>
              <th className="text-right py-1">
                <div>
                  <span style={{ paddingRight: 110 }}>
                    % permitido
                  </span>
                </div>
              </th>
            </tr>
            <tr>
              <td className="px-2 pt-2">Porcentaje máximo de apremios sin radicar:</td>
              <td className="px-2 pt-2 d-flex justify-content-end">
                <div className="d-flex align-items-center justify-content-end evaluacion-form">
                  <Form.Control name="sin_radicar" className="mr-2" onChange={handlePermitidos} value={permitido["sin_radicar"]} disabled={edit !== "sin_radicar"} /> %
                </div>
                <Acciones categoria={"sin_radicar"} edit={edit} handleEdit={handleEdit} handleCancel={handleCancel} handleSave={handleSavePermitidos} maximos />
              </td>
            </tr>
            <tr>
              <td className="px-2 pt-1">Porcentaje máximo de apremios con faltantes:</td>
              <td className="px-2 pt-1 d-flex justify-content-end">
                <div className="d-flex align-items-center justify-content-end evaluacion-form">
                  <Form.Control name="faltantes" className="mr-2" onChange={handlePermitidos} value={permitido["faltantes"]} disabled={edit !== "faltantes"} /> %
                </div>
                <Acciones categoria={"faltantes"} edit={edit} handleEdit={handleEdit} handleCancel={handleCancel} handleSave={handleSavePermitidos} maximos />
              </td>
            </tr>
            <tr>
              <td className="px-2 pt-1">Porcentaje máximo de apremios sin archivar:</td>
              <td className="px-2 pt-1 d-flex justify-content-end">
                <div className="d-flex align-items-center justify-content-end evaluacion-form">
                  <Form.Control name="sin_archivar" className="mr-2" onChange={handlePermitidos} value={permitido["sin_archivar"]} disabled={edit !== "sin_archivar"} /> %
                </div>
                <Acciones categoria={"sin_archivar"} edit={edit} handleEdit={handleEdit} handleCancel={handleCancel} handleSave={handleSavePermitidos} maximos />
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  );
};

export default EvaluacionesConfig;
